import { createSlice } from '@reduxjs/toolkit'

import { reducers } from '.reducers/libraries/bulk.template'

import removeArrayDupsByKey from '.helpers/removeArrayDupsByKey'

const initialState = {
	selected: [],
	showOkButton: false,
	showCompanySelector: false,
}

const imageBulks = createSlice({
	name: 'LIB/IMAGES/BULK',
	initialState,
	reducers: {
		...reducers,
		addMultipleSelected(state, { payload: libArr }) {
			state.selected = removeArrayDupsByKey([...state.selected, ...libArr], {
				selector: 'id',
			}).map((image) => ({
				...image,
				images: { full: image?.image?.preview_url },
			}))
		},




	},
})

export const {
	addSelected,
	setSelected,
	updateSelected,
	removeSelected,
	addMultipleSelected,
	removeMultipleSelected,
	clearSelected,
	setShowOkButton,
	setShowCompanySelector,
	onBulkTagsUpdated,
} = imageBulks.actions

export default imageBulks.reducer
